import { useMutation } from '@apollo/client';

import { CURRENT_EVENT } from '../../event/graphql/query/currentEventQuery.graphql';
import { JOIN_BEDROOM } from '../graphql/mutation/joinBedroomMutation.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';

export const useJoinBedroomMutation = () => {
  const [mutate] = useMutation(JOIN_BEDROOM);

  const joinBedroom = (bedroomId: string, eventId: string) => {
    mutate({
      variables: {
        bedroomId,
        eventId,
      },
      refetchQueries: [EVENT_BEDROOMS, CURRENT_EVENT],
    });
  };

  return { joinBedroom };
};
